import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import denormalize from 'json-api-denormalizer'
import * as actions from './actions'
import { executeIfNotEqual } from '../../util'
import ModuleFetchContainer from '../ModuleFetchContainer/index'
import ModulesPage from '../../components/ModulesPage'

const crudTypes = {
  LIST: 'LIST',
  SHOW: 'SHOW'
}
export { crudTypes }

const modulePaths = [
  '/modules',
  '/modules/search',
  '/modules/:id/:subpage/:sequenceId',
  '/modules/:id/:subpage',
  '/modules/:id/'
]
export { modulePaths }

class ModulesRoutingContainer extends Component {
  componentDidMount(){ this.syncStateWithRoute() }
  componentDidUpdate(){ this.syncStateWithRoute() }

  syncStateWithRoute() {
    const { match, dispatch, crudAction, subpage, sequenceId } = this.props

    // Set primary crud action
    if(match.params.id) {
      executeIfNotEqual(this.props.moduleId, match.params.id, ()=>dispatch(actions.setModuleId(match.params.id)))
      executeIfNotEqual(crudAction, crudTypes.SHOW, ()=>dispatch(actions.setResourceAction(crudTypes.SHOW)))
    } else {
      executeIfNotEqual(crudAction, crudTypes.LIST, ()=>dispatch(actions.setResourceAction(crudTypes.LIST)))
    }

    // Set the subpage
    if(match.params.subpage) {
      const pathToConstant = match.params.subpage.toUpperCase()
      executeIfNotEqual(subpage, pathToConstant, ()=>dispatch(actions.setSubpage(pathToConstant)))
    } else {
      executeIfNotEqual(subpage, 'OVERVIEW', ()=>dispatch(actions.setSubpage('OVERVIEW')))
    }

    // Set or unset the sequence id
    executeIfNotEqual(sequenceId, match.params.sequenceId, ()=>dispatch(actions.setSequenceId(match.params.sequenceId)))
  }

  executeIfNotEqual = (value1, value2, func) => {
    if(value1 !== value2){ func() }
  }

  render() {
    const { props, executeIfNotEqual } = this
    const handleSubpageSelect = newSubpage=>executeIfNotEqual(props.subpage, newSubpage, ()=>props.dispatch(actions.setSubpage(newSubpage)))

    return(
      <ModuleFetchContainer>
        <ModulesPage {...props} handleSubpageSelect={handleSubpageSelect} />
      </ModuleFetchContainer>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { moduleId, sequenceId, crudAction, subpage } = state.modulesRouting
  return { crudAction, subpage: subpage || 'OVERVIEW', moduleId, sequenceId }
}

export { ModulesRoutingContainer };
export default connect(mapStateToProps)(ModulesRoutingContainer);
